import { E_REQUEST_METHOD } from '../ServicesHelpers';
import { serviceCreator } from 'src/services/helpers/serviceCreator';
import { API_ENDPOINT } from '../constants';
export var casesServices = {
    fetchCases: function (realm, payload) {
        return serviceCreator(E_REQUEST_METHOD.POST, API_ENDPOINT.SEARCH.SEARCH(realm), true, {
            data: payload,
            enableDefaultEvents: false,
        });
    },
    fetchAutoSearch: function (realm) { return serviceCreator(E_REQUEST_METHOD.POST, API_ENDPOINT.SEARCH.SEARCH(realm), true); },
    fetchCaseDetails: function (realm, caseToken) {
        return serviceCreator(E_REQUEST_METHOD.GET, API_ENDPOINT.CASES.CASE_DETAILS(realm, caseToken), true);
    },
    exportCasesInCSV: function (realm, payload) {
        return serviceCreator(E_REQUEST_METHOD.POST, API_ENDPOINT.SEARCH.CASES_CSV_EXPORT(realm), true, {
            data: payload,
            headers: { accept: 'text/csv' },
            enableDefaultEvents: true,
        });
    },
    updateDocStatusV4: function (realm, productToken, payload) {
        return serviceCreator(E_REQUEST_METHOD.POST, API_ENDPOINT.CASES.UPDATE_DOC_STATUS_V4(realm, productToken), true, {
            data: payload,
        });
    },
    updateDocStatusV5: function (realm, productToken, payload) {
        return serviceCreator(E_REQUEST_METHOD.POST, API_ENDPOINT.CASES.UPDATE_DOC_STATUS_V5(realm, productToken), true, {
            data: payload,
        });
    },
    sendCommentV4: function (realm, productToken, payload) {
        return serviceCreator(E_REQUEST_METHOD.POST, API_ENDPOINT.CASES.SEND_COMMENTS_V4(realm, productToken), true, {
            data: payload,
            enableDefaultEvents: true,
        });
    },
    sendCommentV5: function (realm, productToken, payload) {
        return serviceCreator(E_REQUEST_METHOD.POST, API_ENDPOINT.CASES.SEND_COMMENTS_V5(realm, productToken), true, {
            data: payload,
            enableDefaultEvents: true,
        });
    },
};
